'use client';

import Link from 'next/link';
import { useRef } from 'react';
import { cn } from '@/app/utils';
import { useBlogSticky } from '../_hooks/use-blog-sticky';
import type { Category } from '../apis';

interface BlogCategoryTabsProps {
  categories: Category[];
  activeCategory?: string;
  /** e.g. "/en/blog"；用于构造 All / 分类的 Link href */
  basePath: string;
}

export default function BlogCategoryTabs({ categories, activeCategory, basePath }: BlogCategoryTabsProps) {
  const tabsRef = useRef<HTMLDivElement>(null);
  const isSticky = useBlogSticky('[data-blog-category-tabs]');

  const stickyCategories = categories.filter((category) => category.isSticky).sort((a, b) => a.order - b.order);

  return (
    <div
      ref={tabsRef}
      data-blog-category-tabs
      className={cn(
        'sticky top-[156px] z-50 w-full py-[30px] transition-colors duration-150 sm:top-[114px] sm:py-[18px]',
        isSticky && 'bg-white',
      )}
    >
      <div className="hide-scrollbar m-auto flex w-full max-w-[1312px] flex-nowrap items-center gap-2 overflow-x-auto px-16 sm:px-4">
        <Link
          prefetch={false}
          href={basePath}
          className={cn(
            'flex h-[28px] min-w-[80px] flex-shrink-0 items-center justify-center rounded-lg px-3 text-center text-[13px] transition-all duration-200',
            !activeCategory ? 'bg-[#0086FF] font-medium text-white' : 'bg-black/5 text-black/70',
          )}
        >
          All
        </Link>

        {stickyCategories.map((category) => (
          <Link
            prefetch={false}
            key={category.slug}
            href={`${basePath}?category=${category.slug}`}
            className={cn(
              'flex h-[28px] min-w-[80px] flex-shrink-0 items-center justify-center rounded-lg px-3 text-center text-[13px] transition-all duration-200',
              activeCategory === category.slug ? 'bg-[#0086FF] font-medium text-white' : 'bg-black/5 text-black/70',
            )}
          >
            {category.name}
          </Link>
        ))}
      </div>
    </div>
  );
}
